import React, { FC, ReactNode } from 'react';
import Content from './Content/Content';
import Header from './Header/Header';
import { SectionElem } from './PageSection.styles';

interface IPageSectionProps {
  ariaLabel?: string;
  children: ReactNode;
  className?: string;
}

interface IPageSection extends FC<IPageSectionProps> {
  Content: typeof Content;
  Header: typeof Header;
}

// eslint-disable-next-line react/prop-types
const PageSection: IPageSection = ({ ariaLabel, children, className }) => (
  <SectionElem aria-label={ariaLabel} id="SectionElem" {...{ className }}>
    {children}
  </SectionElem>
);

PageSection.Header = Header;
PageSection.Content = Content;

export default PageSection;
